module.exports = __webpack_public_path__ + "assets/3GctFGUjZk.woff";